//
import RoleModel from "@/models/Role"

//
export default [
    {
        name: "rut",
        props: {
            label: "Rut",
        },
        type: "text-field",
    }, 
    {
        name: "names",
        props: {
            label: "Nombre",
        },
        type: "text-field",
    }, 
    {
        name: "last_name1",
        props: {
            label: "Primer apellido",
        },
        type: "text-field",
    }, 
    {
        name: "last_name2",
        props: {
            label: "Segundo apellido",
        },
        type: "text-field",
    }, 
    {
        name: "email",
        props: {
            label: "Correo",
        },
        type: "text-field",
    }, 
    {
        name: "role",
        props: {
            chips: true,
            itemText: "role_name",
            itemValue: "id",
            label: "Rol",
            model: RoleModel,
            noObject: true,
            paramSearch: "warehouse_roles",
        },
        type: "autocomplete-model",
    }, 
    {
        name: "is_ground_seller",
        props: {
            chips: true,
            items: [
                {
                    text: "No",
                    value: 0,
                },
                {
                    text: "Si",
                    value: 1,
                },
            ],
            label: "Vendedor en terreno",
        },
        type: "select",
    }, 
]

// names, last_name1, last_name2, email, role, rut, search, is_ground_seller